import { Button, Group, Modal, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";

import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useLibraryState } from "../../hooks/useEditorState";
import { librarySlice } from "../../lib/state/reducer";

export const ConfirmDeletionModal = ({
  open,
  onClose,
  libraryEntry,
}: {
  open: boolean;
  onClose: () => void;
  libraryEntry: number | null;
}): JSX.Element | null => {
  if (libraryEntry === null) {
    return null;
  }
  const theme = useMantineTheme();
  const entryTitle = useLibraryState((state) => state.entries[libraryEntry].present.title);
  const entryId = useLibraryState((state) => state.entries[libraryEntry].present.id);
  const reduxDispatch = useAppDispatch();

  return (
    <Modal
      centered
      opened={open}
      onClose={onClose}
      title={
        <Group spacing="xs" align="center">
          <IconAlertTriangleFilled style={{ color: theme.colors.red[8], marginTop: "4px" }} />
          <Title order={3}>Confirm deletion</Title>
        </Group>
      }
    >
      <Stack spacing={"sm"}>
        <Text>
          You are about to delete <strong>{entryTitle || "(Untitled)"}</strong>. Deletion is{" "}
          <strong>
            <i>permanent</i>
          </strong>{" "}
          and cannot be undone.
        </Text>
        <Text>Do you want to continue?</Text>
        <Group>
          <Button
            color="red.8"
            onClick={() => {
              reduxDispatch(
                librarySlice.actions.deleteDocument({
                  libraryIndex: libraryEntry,
                  documentId: entryId,
                })
              );
              onClose();
            }}
          >
            Delete
          </Button>
          <Button variant="outline" onClick={() => onClose()}>
            Close
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
